import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { MODEL_COLORS } from "@/constants/colors";
import { BASE_LIB_URL } from "@/constants/defaultValue";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const getSMBaseUrl = () => {
  const domain = window.location.hostname;
  const prefix = domain.startsWith("pre-") ? "pre-" : "";
  return `https://${prefix}qtbh.kido.vn`;
};

export const getDomainPrefix = () => {
  const domain = window.location.hostname;
  return domain.startsWith("pre-") ? "pre-" : "";
};

export function getCssUrl() {
  // const domain = window.location.hostname;
  // if (domain === "localhost") {
  //   return "http://localhost:8000/ai-chat.css";
  // }

  // const prefix = getDomainPrefix();
  // const url = `https://${prefix}qa.kido.vn/qa/ai-chat.css`;
  const url = `${BASE_LIB_URL}/lib/ai-chat.css`;
  return url;
}

export async function loadExternalStyleSheet() {
  try {
    const url = getCssUrl();
    const response = await fetch(url);
    const cssText = await response.text();
    return cssText;
  } catch (error) {
    console.error("Failed to load external stylesheet:", error);
    return null;
  }
}

export const getQueryParams = (key) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
};

export const redirectToLogin = () => {
  window.location.href = "https://id.kido.vn/login/?redirect_url=" + encodeURI(location.href);
};

export const removeQueryParams = (key) => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete(key);
  window.history.replaceState({}, "", window.location.pathname + urlParams.toString());
};

export const assignColorsToModels = (modelNames) => {
  if (!Array.isArray(modelNames)) return [];

  return modelNames.map((name, index) => ({
    name,
    color: MODEL_COLORS[index % MODEL_COLORS.length],
  }));
};
